export enum MasterVisible {
    HIDE = 1,
    FORMVIEW = 2,
    GRIDVIEW = 3,
    FORM_GRID_VIEW = 4
 }

 export const FORM_VISIBLITY = [MasterVisible.FORMVIEW, MasterVisible.FORM_GRID_VIEW]